import { createContext, useContext } from 'react'
import { useCurrentUser, useLogout } from '@/hooks/useAuth'
import type { TenantUser } from '@/types'

interface AuthContextType {
  user: TenantUser | null
  isLoading: boolean
  isAuthenticated: boolean
  logout: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading } = useCurrentUser()
  const logoutFunction = useLogout()
  const isAuthenticated = !!user

  const logout = () => {
    logoutFunction()
  }

  return (
    <AuthContext.Provider value={{
      user: user || null,
      isLoading,
      isAuthenticated,
      logout,
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}